import { useNavigate } from "react-router";
import { useUrlProvider } from "../../useUrlProvider.ts";
import { useUserContext } from "../../auth/userContextProvider/UserContextProvider.tsx";
import { useState } from "react";
import { ContractModel } from "./Contract.types.ts";
import { AccessControlEntity, isRemovingOwnAccess } from "../../entityTemplates/fields/useAccessResponsibilityHelper.hooks.ts";

export function useContractResponsibilityHelper(onChange: (changeFunc: (contract: ContractModel) => void) => Promise<void>, disableAccessWarning?: boolean) {
    const navigate = useNavigate();
    const urlProvider = useUrlProvider();

    const { businessAreas: userBusinessAreas, userProfileId } = useUserContext();
    const [pendingUserChanges, setPendingUserChanges] = useState<ContractModel | null>(null);

    async function handleDialogConfirm() {
        await onChange((contract: ContractModel) => {
            Object.assign(contract, pendingUserChanges!);
        });

        setPendingUserChanges(null);
        navigate(urlProvider.getContractsUrl());
    }

    const onFieldChange = (newContract: ContractModel, oldContract: ContractModel) => {
        if (
            !disableAccessWarning &&
            isRemovingOwnAccess(mapToAccessControlEntity(newContract), mapToAccessControlEntity(oldContract), userProfileId, userBusinessAreas)
        ) {
            setPendingUserChanges(newContract);
        } else {
            onChange((contract: ContractModel) => {
                Object.assign(contract, newContract);
            });
        }
    };

    return { onFieldChange, handleDialogConfirm, pendingUserChanges, setPendingUserChanges };
}

function mapToAccessControlEntity(contract: ContractModel): AccessControlEntity {
    return {
        responsibleId: contract.contractManagerId,
        accessBusinessAreas: contract.contractAccessBusinessAreas,
        visibleToAllUsers: contract.visibleToAllUsers,
        allGroupEntityAccess: contract.allGroupEntityAccess,
        groupEntities: contract.groupEntities,
        excludedUsers: contract.excludedUsers,
        additionalAccessUsers: contract.additionalAccessUsers,
    };
}
